import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

/**
 * Cookie-Einstellungsseite öffnet den globalen Cookie-Banner/Dialog,
 * damit Banner und Einstellungsseite immer denselben Consent-Flow nutzen.
 */
export default function CookieSettingsPage() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const timer = window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent('open-cookie-settings'));
    }, 50);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <>
      <Header />
      <main className="bg-[#0B1220] px-4 pt-32 pb-10 md:pt-40 md:pb-12 min-h-screen">
        <div className="max-w-4xl mx-auto rounded-[32px] border border-white/10 bg-white/[0.08] backdrop-blur-2xl shadow-[0_30px_100px_rgba(0,0,0,0.45)] px-6 py-8 md:px-10 md:py-10 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-white/[0.08] via-transparent to-transparent pointer-events-none" />

          <div className="relative z-10">
            <p className="text-[11px] md:text-xs uppercase tracking-[0.22em] text-[#D4AF37] mb-3">
              Datenschutz & Einwilligung
            </p>

            <h1 className="text-2xl md:text-4xl font-semibold tracking-tight text-white mb-4 leading-tight">
              Cookie-Einstellungen
            </h1>

            <p className="text-sm md:text-base text-white/80 leading-relaxed mb-4 max-w-3xl">
              Deine Cookie-Auswahl wird über denselben globalen Consent-Dialog verwaltet wie auf allen anderen Seiten. Dadurch bleiben Banner, Tracking und Widerruf immer synchron.
            </p>

            <p className="text-sm md:text-base text-white/75 leading-relaxed mb-8 max-w-3xl">
              Der Cookie-Dialog wurde automatisch geöffnet. Falls er nicht sichtbar ist, nutze bitte den Footer-Link „Cookie-Einstellungen“ oder lade die Seite kurz neu.
            </p>

            <div className="rounded-3xl border border-white/10 bg-black/20 px-5 py-5 md:px-6 md:py-6">
              <h2 className="text-sm md:text-base font-semibold tracking-[0.14em] uppercase text-[#D4AF37] mb-3">
                Wichtiger Hinweis
              </h2>
              <p className="text-xs md:text-sm text-white/75 leading-relaxed mb-3">
                Technisch notwendige Cookies bleiben immer aktiv. Optionale Dienste wie Google Ads oder andere Marketing- und Statistikdienste werden nur nach deiner ausdrücklichen Einwilligung geladen.
              </p>
              <p className="text-xs md:text-sm text-white/75 leading-relaxed">
                Weitere Informationen zur Verarbeitung personenbezogener Daten, zu eingesetzten Diensten und zu deinen Rechten findest du in unserer{' '}
                <a
                  href="/datenschutz"
                  className="font-medium underline underline-offset-4 text-[#D4AF37] hover:text-white transition-colors"
                >
                  Datenschutzerklärung
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
